<script setup lang="ts">
import { computed } from 'vue'
import { pendingApprovalNotice, dismissPendingApproval } from '@/lib/approvalNotice'

const notice = pendingApprovalNotice

const detailPath = computed(() => {
  if (!notice.value) return ''
  return `/dashboard/${notice.value.project}/change-requests/${notice.value.changeRequest.id}`
})

const changeCount = computed(() => notice.value?.changeRequest.changes.length ?? 0)
</script>

<template>
  <Transition name="fade">
    <div
      v-if="notice"
      class="fixed bottom-lg right-lg z-50 max-w-md bg-surface-container-high rounded-md shadow-lg border border-warning/30 p-md flex items-start gap-sm"
      role="status"
    >
      <svg class="w-5 h-5 text-warning flex-shrink-0 mt-2xs" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 3h-4.18C13.4 1.84 12.3 1 11 1c-1.3 0-2.4.84-2.82 2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L9 14.17l6.59-6.59L17 9l-8 8z" />
      </svg>
      <div class="flex-1 min-w-0">
        <p class="text-body-sm text-text-primary font-body">
          {{ notice.amended ? 'Added to your pending change request' : 'Submitted for approval' }}
        </p>
        <p class="text-body-sm text-text-muted">
          {{ notice.changeRequest.environmentName }} requires approval — {{ changeCount }} change{{ changeCount !== 1 ? 's' : '' }} pending review{{ notice.amended ? ' (approvals reset)' : '' }}.
        </p>
        <router-link
          :to="detailPath"
          class="text-body-sm text-primary hover:underline"
          @click="dismissPendingApproval"
        >
          View change request
        </router-link>
      </div>
      <button
        class="text-text-muted hover:text-text-primary transition-colors duration-short flex-shrink-0"
        aria-label="Dismiss"
        @click="dismissPendingApproval"
      >
        <svg class="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        </svg>
      </button>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
